import { Route, Routes } from 'react-router-dom'
import RemoveData from './Routes/RemoveData/RemoveData'
import Trash from './Routes/Trash/Trash'

const Content = () => {
    return (
        <Routes>
            <Route
                path={'/remove-data'}
                element={
                    <RemoveData />
                }
            />
            <Route
                path={'/trash'}
                element={
                    <Trash />
                }
            />
        </Routes>
    )
}

export default Content